import * as actions from "../../../actions/productCategory/report";

const initialState = {
  loading: false,
  items: [],
  pages: null,
  filter: []
};

const reducer = function(state = initialState, { type, payload }) {
  switch (type) {
    case actions.CLEAR_ITEMS: {
      return {
        ...state,
        items: [],
        loading: true
      };
    }
    case actions.GET_PRODUCTCATEGORIES: {
      return {
        ...state,
        loading: true
      };
    }
    case actions.DELETE_PRODUCTCATEGORY: {
      return {
        ...state,
        loading: true
      };
    }
    case actions.GET_PRODUCTCATEGORIES_FAILED: {
      return {
        ...state,
        loading: false
      };
    }
    case actions.DELETE_PRODUCTCATEGORY_FAILED: {
      return {
        ...state,
        loading: false
      };
    }
    case actions.GET_PRODUCTCATEGORIES_SUCCESS: {
      return {
        ...state,
        items: payload ? payload : [],
        loading: false
      };
    }
    case actions.DELETE_PRODUCTCATEGORY_SUCCESS: {
      return {
        ...state,
        items: payload ? payload : [],
        loading: false
      };
    }
    case actions.SET_VALUE: {
      return {
        ...state,
        ...payload
      };
    }
    default: {
      return state;
    }
  }
};

export default reducer;
